"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XLSX = exports.formatFunctions = void 0;
var xlsx_1 = __importDefault(require("xlsx"));
var functions_1 = require("./functions");
exports.formatFunctions = {
    d: function (cell) {
        cell.z = 'DD-MM-YYYY';
        cell.t = 'n';
        var date = new Date(cell.v);
        cell.v = date.getTime() / (86400 * 1000) + (25567 + 2);
        return cell;
    },
    t: function (cell) {
        var date = new Date("1989-01-01 ".concat(cell.v));
        if (isNaN(date.getTime()))
            return cell;
        cell.z = 'HH:MM';
        cell.t = 'n';
        cell.v = date.getTime() / (86400 * 1000) + (25567 + 2) + 1 / 24;
        return cell;
    },
    n: function (cell) {
        cell.t = 'n';
        return cell;
    },
    dp: function (cell) {
        if (typeof cell.v === 'number' || !isNaN(Number(cell.v)))
            cell.t = 'n';
        cell.z = '0.00';
        return cell;
    },
    str: function (cell) {
        cell.t = 's';
        return cell;
    },
};
var XLSX = /** @class */ (function () {
    function XLSX() {
        (0, functions_1.bindClassFunctions)(this);
    }
    XLSX.prototype.aoaToXLS = function (data, sheetName, formating, columnWidths, fileType) {
        if (fileType === void 0) { fileType = 'xlsx'; }
        var workBook = this.generateSheet(data, sheetName, formating);
        if (columnWidths) {
            workBook = this.addColumnWidthsToSheet(workBook, sheetName, columnWidths);
        }
        var workBookBuffer = xlsx_1.default.write(workBook, {
            bookType: fileType,
            type: 'binary',
            bookSST: true,
            compression: true,
        });
        return this.binary2ocet(workBookBuffer);
    };
    XLSX.prototype.addColumnWidthsToSheet = function (workBook, sheetName, columnWidths) {
        workBook.Sheets[sheetName]['!cols'] = columnWidths.map(function (width) { return ({ wch: width }); });
        return workBook;
    };
    XLSX.prototype.workBookToBuffer = function (workBook, bookType) {
        if (bookType === void 0) { bookType = 'xlsx'; }
        var workBookBuffer = xlsx_1.default.write(workBook, {
            bookType: bookType,
            type: 'buffer',
            bookSST: true,
            compression: true,
        });
        return workBookBuffer;
    };
    XLSX.prototype.generateSheet = function (data, sheetName, formating, omitRows) {
        var _a;
        if (omitRows === void 0) { omitRows = {
            start: undefined,
            end: 0,
        }; }
        var startIndex = (omitRows.start ? omitRows.start : ((_a = data[1]) === null || _a === void 0 ? void 0 : _a.length) ? 1 : 3);
        var endIndex = data.length - omitRows.end;
        var wb = xlsx_1.default.utils.book_new();
        wb.SheetNames.push(sheetName);
        var ws = xlsx_1.default.utils.aoa_to_sheet(data);
        wb.Sheets[sheetName] = ws;
        return wb;
    };
    XLSX.prototype.createWorkBook = function () {
        return xlsx_1.default.utils.book_new();
    };
    XLSX.prototype.aoaToWorkSheet = function (data) {
        return xlsx_1.default.utils.aoa_to_sheet(data);
    };
    XLSX.prototype.addSheetToBook = function (workBook, workSheet, sheetName) {
        workBook.SheetNames.push(sheetName);
        workBook.Sheets[sheetName] = workSheet;
        return workBook;
    };
    XLSX.prototype.applyFormatting = function (workSheet, startCell, endCell, formatsPerColumn, repeatColumnFormatsToMatchSelectedColumns) {
        if (repeatColumnFormatsToMatchSelectedColumns === void 0) { repeatColumnFormatsToMatchSelectedColumns = false; }
        if (startCell.c > endCell.c || startCell.r > endCell.r)
            throw new Error("Cannot select cells between ".concat(xlsx_1.default.utils.encode_cell(startCell), " and ").concat(xlsx_1.default.utils.encode_cell(endCell)));
        var columnFormats = formatsPerColumn;
        var numberOfColumns = endCell.c - startCell.c;
        if (repeatColumnFormatsToMatchSelectedColumns) {
            var repeatedFormats = [];
            for (var i = 0; i < numberOfColumns; i++) {
                var index = i % columnFormats.length;
                repeatedFormats.push(columnFormats[index]);
            }
            columnFormats = repeatedFormats.slice(0, numberOfColumns);
        }
        if (numberOfColumns !== columnFormats.length)
            throw new Error('You must provide formatting for each column');
        var numberOfRows = endCell.r - startCell.r + 1;
        columnFormats.forEach(function (format, columnIndex) {
            var formatFunction = exports.formatFunctions[format];
            for (var rowIndex = 0; rowIndex < numberOfRows; rowIndex++) {
                var cellAddress = xlsx_1.default.utils.encode_cell({ r: startCell.r + rowIndex, c: startCell.c + columnIndex });
                if (workSheet[cellAddress])
                    workSheet[cellAddress] = formatFunction(workSheet[cellAddress]);
            }
        });
        return workSheet;
    };
    XLSX.prototype.binary2ocet = function (data) {
        var buf = new ArrayBuffer(data.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i < data.length; i++)
            view[i] = data.charCodeAt(i) & 0xff; // convert to octet
        return buf;
    };
    return XLSX;
}());
exports.XLSX = XLSX;
